/**
 * The settings tab registry (D-14): every module's `settings-tabs.ts` — this module's own tabs and, from wave B, the
 * accounting tabs of `src/modules/settings-accounting/settings-tabs.ts` — collected at build time. Adding a tab touches
 * no file of this module; the contract is in `./README.md` and `./utils/tabs.ts`.
 */
import { collectTabs, type RegisteredTab, type TabModules } from './utils/tabs'

export type { RegisteredTab, SettingsTabDefinition, SettingsTabProps } from './utils/tabs'

export const settingsTabs: readonly RegisteredTab[] = collectTabs(
  import.meta.glob<{ default?: unknown }>('/src/modules/*/settings-tabs.ts', { eager: true }) as TabModules,
)

/** The registered tab of a slug (any software), or `undefined`. */
export function findTab(slug: unknown): RegisteredTab | undefined {
  return typeof slug === 'string' ? settingsTabs.find((tab) => tab.slug === slug) : undefined
}

/** The module folders that contribute tabs (their catalogues are loaded with the settings page's). */
export const contributingModules: readonly string[] = [...new Set(settingsTabs.map((tab) => tab.moduleId))]
